import { gql } from '@apollo/client';
// Query for validated meter reads
export const VALIDATED_METER_READS = gql`
  query ValidatedMeterReads($monthYear: String) {
    validatedMeterReads(monthYear: $monthYear) {
      meter_computed_id
      meter_id
      meter_number
      vendor_name
      location
      units_delivered
      units_consumed
      prod_stat_netgen
      percent_change_net_units
      meter_read_type
      comments
      remediated
      approval_status
      ready_for_approval
      manual_adj_for_netgen
      manual_kwh_adjustment
      manual_kwh_adjustment_comments
      prod_stat_approval_signature
      prod_stat_approved_at
      gl_number
      rate
      dollar_value
      operationalStatus
    }
  }
`;
// Query for corrupted meter reads
export const CORRUPTED_METER_READS = gql`
  query CorruptedMeterReads($monthYear: String) {
    corruptedMeterReads(monthYear: $monthYear) {
      meter_computed_id
      location
      meter_id
      meter_number
      vendor_name
      units_delivered
      units_consumed
      prod_stat_netgen
      percent_change_net_units
      meter_read_type
      comments
      remediated
      approval_status
      manual_adj_for_netgen
      manual_kwh_adjustment
      manual_kwh_adjustment_comments
      operationalStatus
      operationalStatusDate
      isInactiveThisMonth
      month_year
    }
  }
`;
export const CHECK_MONTH_APPROVAL_STATUS = gql`
  query CheckMonthApprovalStatus($monthYear: String!) {
    checkMonthApprovalStatus(monthYear: $monthYear) {
      hasApprovedRecords
      monthYear
    }
  }
`;
// Query for available locations
export const AVAILABLE_LOCATIONS = gql`
  query AvailableLocations {
    availableLocations
  }
`;

// Query for orphan meter readings
export const ORPHAN_METER_READINGS = gql`
  query OrphanMeterReadings($meterId: Int!) {
    orphanMeterReadings(meterId: $meterId) {
      orphan_meter_id
      meter_id
      meter_computed_id
      location
      month_year
      retired_meter_number
      new_meter_number
      retired_actual_generated
      retired_actual_used
      retired_actual_net
      new_actual_generated
      new_actual_used
      new_actual_net
      consolidated_generated
      consolidated_used
      consolidated_net
    }
  }
`;

// Mutation for bulk update
// processAsync (Step 0 — async wrapper): optional, only meaningful when updates has
// more than one entry — routes the call through the background job instead of
// processing inline. Omitted/false is the original synchronous behavior, unchanged.
export const UPDATE_METER_DATA_BULK = gql`
  mutation UpdateMeterDataBulk($updates: [MeterDataInput!]!, $processAsync: Boolean) {
    updateMeterDataBulk(updates: $updates, processAsync: $processAsync) {
      approved
      agcStatus
      agcErrors {
        meterName
        error
      }
      queued
      jobId
    }
  }
`;

// Polled after an async bulk approval (processAsync) until status is succeeded/failed,
// then the affected rows are flipped to Approved in place — no page refresh.
export const BULK_APPROVAL_JOB_STATUS = gql`
  query BulkApprovalJobStatus($jobId: Int!) {
    bulkApprovalJobStatus(jobId: $jobId) {
      jobId
      status
      approvedMeterComputedIds
      agcErrors {
        meterName
        error
      }
      errorMessage
    }
  }
`;

// Mutation for moving meters to approval
export const MOVE_METERS_TO_APPROVAL = gql`
  mutation MoveMetersToApproval($ids: [Int!]!) {
    moveMetersToApproval(ids: $ids)
  }
`;

// Mutation to mark a meter as decommissioned in MeterMaster
export const DECOMMISSION_METER = gql`
  mutation DecommissionMeter($meterId: Int!) {
    decommissionMeter(meterId: $meterId)
  }
`;
